import React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import { MediaGallery } from 'containers';
import { useParams, useHistory } from 'react-router-dom'

const ThePage = () => {
  const { subweb } = useParams();
  const history = useHistory();

  const handleSelect = file => {
    const { id } = file
    history.push(`/${subweb}/assets/${id}`);
  }

  return (
    <Layout subtitle="Galeria de imagens" hasSubwebHeader>
      <MediaGallery
        modifiers={['stretch']}
        shouldPreview={false}
        onSelect={handleSelect}
        onClickUpload={() => history.push(`/${subweb}/assets/upload`)}
        onlyEditable
      />
    </Layout>
  );
};

const Page = styled.div``;

Page.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;

export default ThePage;
